import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "./App.scss";
import "./fontawesome/css/all.min.css";
import "bootstrap/scss/bootstrap.scss";

import Home from "./neetjee_guru/pages/Home";
import HomeExam from "./neetjee_guru/pages/HomeExam";
import StudentOrganizationProfile from "./neetjee_guru/pages/StudentOrganizationProfile";
import Login from "./neetjee_guru/pages/Login";
import CollegeLogin from "./neetjee_guru/pages/college";
import StudentSuccessRegister from "./student_module/pages/Success";
import StudentFailureRegister from "./student_module/pages/Failure";
import Package from "./neetjee_guru/pages/Package";
import Category from "./neetjee_guru/pages/Category";
import Branches from "./neetjee_guru/pages/Branches";
import AddSection from "./neetjee_guru/pages/AddSection";
import Groups from "./neetjee_guru/pages/Groups";
import Teachers from "./neetjee_guru/pages/Teachers";
import Students from "./neetjee_guru/pages/Students";
import OrganizationSetup from "./neetjee_guru/pages/OrganizationSetup";
import OrganizationProfile from "./neetjee_guru/pages/OrganizationProfile";
import PromoteStudent from "./neetjee_guru/pages/PromoteStudent";
import CreateQuestionPaper from "./neetjee_guru/pages/CreateQuestionPaper";
import OwnQuestionPaper from "./neetjee_guru/pages/OwnQuestionPaper";
import OwnQuestionCustom from "./neetjee_guru/pages/OwnQuestionCustom";
import QuestionsPreview from "./neetjee_guru/pages/QuestionsPreview";
import OwnQuestionCustompresent from "./neetjee_guru/pages/OwnQuestionCustompresent";
import OwnQuestionOldpresent from "./neetjee_guru/pages/OwnQuestionOldpresent";
import OwnQuestionCollegeExam from "./neetjee_guru/pages/OwnQuestionCollegeExam";
import OwnQuestionCumulative from "./neetjee_guru/pages/OwnQuestionCumulative";
import OwnQuestionChapter from "./neetjee_guru/pages/OwnQuestionChapter";
import OwnQuestionSemiGrand from "./neetjee_guru/pages/OwnQuestionSemiGrand";
import OwnQuestionGrand from "./neetjee_guru/pages/OwnQuestionGrand";
import ManageQuestionPaper from "./neetjee_guru/pages/ManageQuestionPaper";
import QuestionPaperResult from "./neetjee_guru/pages/QuestionPaperResult";
import Settings from "./neetjee_guru/pages/Settings";
import AdaptiveQuestionPaper from "./neetjee_guru/pages/AdaptiveQuestionPaper";
import ErrorQuestion from "./neetjee_guru/pages/ErrorQuestion";
import OurQuestions from "./neetjee_guru/pages/OurQuestions";
import ManageOurQuestionPaper from "./neetjee_guru/pages/ManageOurQuestionPaper";
import QuestionPattern from "./neetjee_guru/pages/QuestionPattern";
import CreateQuestionPattern from "./neetjee_guru/pages/CreateQuestionPattern";
import CreateCustomQuestionPaper from "./neetjee_guru/pages/CreateCustomQuestionPaper";
import CreateCustomSummery from "./neetjee_guru/pages/CreateCustomSummery";
import PageNotFound from "./neetjee_guru/pages/PageNotFound";
import UserCreations from "./neetjee_guru/pages/UserCreations";
import NotifyStudents from "./neetjee_guru/pages/NotifyStudents";
import ResultAnalysisCollege from "./neetjee_guru/pages/ResultAnalysis";
import PracticeExamAnalysisCollege from "./neetjee_guru/pages/PracticeExamAnalysis";
import StrengthAnalysisCollege from "./neetjee_guru/pages/StrengthAnalysis";
import TimeAnalysisCollege from "./neetjee_guru/pages/TimeAnalysis";
import ComplexityAnalysisCollege from "./neetjee_guru/pages/ComplexityAnalysis";
import ErrorAnalysisCollege from "./neetjee_guru/pages/ErrorAnalysis";
import QuestionTypeAnalysisCollege from "./neetjee_guru/pages/QuestionTypeAnalysis";
import OwnQuestionMockExam from "./neetjee_guru/pages/OwnQuestionMockExam";
import OwnQuestionCustomEdit from "./neetjee_guru/pages/OwnQuestionCustomEdit";
import Quiz from "./neetjee_guru/pages/Quiz";
import EditQuiz from "./neetjee_guru/pages/EditQuiz";
import HomeDashboard from "./neetjee_guru/pages/HomeDashBoard";
import ExamReport from "./neetjee_guru/pages/ExamReport";
import ExamMadeEasy from "./neetjee_guru/pages/ExamMadeEasy";
import UpdateExamMadeEasy from "./neetjee_guru/pages/UpdateExamMadeEasy";
import ExamMadeEasyDraftQuestionView from "./neetjee_guru/pages/ExamMadeEasyDraftQuestionView";
import LecPaperGenerator from "./neetjee_guru/pages/LecPaperGenerator";
import EditLecPaperGenerator from "./neetjee_guru/pages/EditLecPaperGenerator";
import StudentAttendance from "./neetjee_guru/pages/StudentAttendance";
import StudentAttendanceReport from "./neetjee_guru/pages/StudentAttendanceReport";
import StudentMarksUploading from './neetjee_guru/pages/StudentMarksUploading';
import OfflineFeeStructure from './neetjee_guru/pages/offlineFeeStructure'
import OfflineExamResults from './neetjee_guru/pages/offlineExamResults'
import FeeStructure from './neetjee_guru/pages/FeeStructure'
import EducationManagementStudents from './neetjee_guru/pages/EducationManagementStudents'
import EmployeeRestrictions from './neetjee_guru/pages/EmployeeRestrictions'
import EmployeeAttendance from './neetjee_guru/pages/EmployeeAttendance'
import EmployeeAttendanceReport from './neetjee_guru/pages/EmployeeAttendanceReport'
import StudentAdmission from './neetjee_guru/pages/StudentAdmission';
import StudentAdmissionList from './neetjee_guru/pages/StudentAdmissionList';
import GatePass from "./neetjee_guru/pages/gatePass";
import ParentNotification from "./neetjee_guru/pages/ParentNotification";
import BuildingCreation from "./neetjee_guru/pages/buildingCreation";
import HostelAttendance from "./neetjee_guru/pages/HostelAttendance";
import HostelAttendanceReport from "./neetjee_guru/pages/HostelAttendanceReport";
import MeatrialAssigning from "./neetjee_guru/pages/meatrialAssigning";
import MaterialReport from "./neetjee_guru/pages/MaterialReport";
import MaterialStore from "./neetjee_guru/pages/MaterialStore";
import Assignment from "./neetjee_guru/pages/Assignment";
import AssignmentNextPage from "./neetjee_guru/pages/AssignmentNextPage";

//Student Module
import ForgotPassword from "./student_module/pages/ForgotPassword";
import StudentPageNotFound from "./student_module/pages/PageNotFound";
import StudentLogin from "./student_module/pages/StudentLogin";
import StudentRegister from "./student_module/pages/StudentRegister";
import StudentHome from "./student_module/pages/StudentHome";
import LearnPractice from "./student_module/pages/LearnPractice";
import Subjects from "./student_module/pages/Subjects";
import NewTopics from "./student_module/pages/NewTopics";
import Chapter from "./student_module/pages/Chapter";
import OverAllChapterStrength from "./student_module/pages/OverAllChapterStrength";
import PracticeAndExamHistory from "./student_module/pages/PracticeAndExamHistory";
import ExamHistory from "./student_module/pages/ExamHistory";
import StartErrorExam from "./student_module/pages/StartErrorExam";
import WatchingVideo from "./student_module/pages/WatchingVideo";
import RevisionMaterial from "./student_module/pages/RevisionMaterial";
import SingleVideo from "./student_module/pages/SingleVideo";
import SingleShortNote from "./student_module/pages/SingleShortNote";
import PracticeInstructions from "./student_module/pages/PracticeInstructions";
import CustomInstructions from "./student_module/pages/CustomInstructions";
import PracticeSubmitback from "./student_module/pages/PracticeSubmitback";
import CustomsubmitBack from "./student_module/pages/CustomsubmitBack";
import PracticeExam from "./student_module/pages/PracticeExam";
import StudentAssistentExam from "./student_module/pages/StudentAssistentExam";
import ViewQuestionAnswer from "./student_module/pages/ViewQuestionAnswer";
import PracticeViewQuestionAnswer from "./student_module/pages/PracticeViewQuestionAnswer";
import PracticeErrorExam from "./student_module/pages/PracticeErrorExam";
import CustomExamTest from "./student_module/pages/CustomExamTest";
import Exam from "./student_module/pages/Exam";
import ScheduleExam from "./student_module/pages/ScheduleExam";
import ExamsHistory from "./student_module/pages/ExamsHistory";
import CustomExam from "./student_module/pages/CustomExam";
import PreviousPaper from "./student_module/pages/PreviousPaper";
import CustomPreviousPaper from "./student_module/pages/CustomPreviousPaper";
import AdaptiveExam from "./student_module/pages/AdaptiveExam";
import ErrorExam from "./student_module/pages/ErrorExam";
import GetReadyForExam from "./student_module/pages/GetReadyForExam";
import ChapterExam from "./student_module/pages/ChapterExam";
import CumulativeExam from "./student_module/pages/CumulativeExam";
import GetReadySemiGrandExam from "./student_module/pages/GetReadySemiGrandExam";
import GetReadyGrandExam from "./student_module/pages/GetReadyGrandExam";
import GetReadyExamHistory from "./student_module/pages/GetReadyExamHistory";
import GetReadyExamUpcomingHistory from "./student_module/pages/GetReadyExamUpcomingHistory";
import GetReadyShortNoteMaterialRevisions from "./student_module/pages/GetReadyShortNoteMaterialRevisions";
import GetReadySingleShortNoteMaterialRevisions from "./student_module/pages/GetReadySingleShortNoteMaterialRevisions";
import Bookmarks from "./student_module/pages/Bookmarks";
import BookmarkVideos from "./student_module/pages/BookmarkVideos";
import SingleBookmarkVideo from "./student_module/pages/SingleBookmarkVideo";
import BookmarkShortnotesMaterials from "./student_module/pages/BookmarkShortnotesMaterials";
import BookmarkSingleShortNoteMaterialRevisions from "./student_module/pages/BookmarkSingleShortNoteMaterialRevisions";
import BookmarkPracticeQuestions from "./student_module/pages/BookmarkPracticeQuestions";
import BookmarkExamQuestions from "./student_module/pages/BookmarkExamQuestions";
import Profile from "./student_module/pages/Profile";
import Notes from "./student_module/pages/Notes";
import NoteVideos from "./student_module/pages/NoteVideos";
import SingleNotesVideo from "./student_module/pages/SingleNotesVideo";
import NotesShortnotesMaterials from "./student_module/pages/NotesShortnotesMaterials";
import NotesSingleShortNoteMaterialRevisions from "./student_module/pages/NotesSingleShortNoteMaterialRevisions";
import NotesPracticeQuestions from "./student_module/pages/NotesPracticeQuestions";
import NotesExamQuestions from "./student_module/pages/NotesExamQuestions";
import NotesSingleMaterialRevisions from "./student_module/pages/NotesSingleMaterialRevisions";
import ResultAnalysis from "./student_module/pages/ResultAnalysis";
import PracticeExamAnalysis from "./student_module/pages/PracticeExamAnalysis";
import StrengthAnalysis from "./student_module/pages/StrengthAnalysis";
import TimeAnalysis from "./student_module/pages/TimeAnalysis";
import ComplexityAnalysis from "./student_module/pages/ComplexityAnalysis";
import ErrorAnalysis from "./student_module/pages/ErrorAnalysis";
import QuestionTypeAnalysis from "./student_module/pages/QuestionTypeAnalysis";
import Notification from "./student_module/pages/Notification";
import AllNotifications from "./student_module/pages/AllNotifications";
import StudentPackage from "./student_module/pages/StudentPackage";
import RevisionMaterialGroups from "./student_module/pages/RevisionMaterialGroups";
import CustomRevisionMaterials from "./student_module/pages/CustomRevisionMaterials";
import CustomSingleRevisionMaterial from "./student_module/pages/CustomSingleRevisionMaterial";
import StudentLoading from "./student_module/pages/StudentLoading";
import StudentFeedBack from './student_module/pages/StudentFeedBack';
import PreviousPaperAnalysis from './student_module/pages/PreviousPaperAnalysis';
import LinkageChapterAnalysis from './student_module/pages/LinkageChapterAnalysis';
import PracticeTestExamResult from './student_module/pages/PracticeTestExamResult';
import PracticeExamResult from './student_module/pages/PracticeExamResult';
import CustomPracticeExamResult from './student_module/pages/CustomPracticeExamResult';
import SingleVideoWatching from './student_module/pages/SingleVideoWatching';
import OrderSummary from './student_module/pages/OrderSummary';
import CustomPractiseExam from './student_module/pages/CustomPractiseExam';
import Videos from './student_module/pages/Videos';
import VideosRecentlyWatched from './student_module/pages/VideosRecentlyWatched';
import MocktestAnalysis from './neetjee_guru/pages/MocktestsAnalysis'
import StudentOrganizationProfileEamcet from './neetjee_guru/pages/studentOrganizationProfileEamcet';
import LecturerTimeTable from "./neetjee_guru/pages/LecturerTimeTable";
import StudentPermission from "./neetjee_guru/pages/StudentPermission";
import StudentDiary from "./neetjee_guru/pages/studentDiary";
import LeadManagement from "./neetjee_guru/pages/LeadManagement";
import LeadsFollowups from "./neetjee_guru/pages/LeadsFollowups";
import EnquiryLink from "./neetjee_guru/pages/enquiry_links";
import InstitureRevisionMaterial from "./neetjee_guru/pages/InstitureRevisionMaterial";
import LeadManagementNew from "./neetjee_guru/pages/LeadManagementNew";



class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: "wrapper",
      isCollegeDomain: false,
      currentPath: "",

    };
  }


  menuToggler = () => {
    const { toggled } = this.state;
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
    } else {
      this.setState({ toggled: "wrapper" });
    }
  };


  componentDidMount() {
    // Get domain and path after the component mounts to avoid updates during render
    const domain = window.location.hostname;
    const path = window.location.pathname;

    // Update the state based on the domain and path
    this.setState({
      isCollegeDomain: domain === "college.rizee.in",
      currentPath: path,
    });
  }

  render() {
    const { isCollegeDomain, currentPath } = this.state;
    return (
      <Router>
        <div className="App">
          <div className={this.state.toggled}>
            <Switch>
              {/* <Route exact path="/login" component={Login} />
              <Route exact path="/college/login" component={CollegeLogin} /> */}
            {
              isCollegeDomain && currentPath === "/login" ? (
                <Route exact path="/login" component={Login} />
              ) : (
                <Route exact path="/login" component={Login} />
              )}
              <Route
                exact
                path="/student/payment-success/:id/:mobile/:name/:token"
                render={(props) => (
                  <StudentSuccessRegister
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/payment-failure/:id/:planid/:mobile/:coupnid/:name/:token"
                render={(props) => (
                  <StudentFailureRegister
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/monitor/dashboard"
                render={(props) => (
                  <Home changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/home-exam"
                render={(props) => (
                  <HomeExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/ExamReport"
                render={(props) => (
                  <ExamReport
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/exam_made_easy"
                render={(props) => (
                  <ExamMadeEasy
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/exam_made_easy/edit_exam_made_easy/EditExamMadeEasy"
                render={(props) => (
                  <UpdateExamMadeEasy
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/exam_made_easy/draft_question_view/DraftQuestionsView"
                render={(props) => (
                  <ExamMadeEasyDraftQuestionView
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/home/student-profile"
                render={(props) => (
                  <StudentOrganizationProfile
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/settings/package"
                render={(props) => (
                  <Package changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/settings/category"
                render={(props) => (
                  <Category
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/settings/branches"
                render={(props) => (
                  <Branches
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/add-section"
                render={(props) => (
                  <AddSection
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/groups"
                render={(props) => (
                  <Groups changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/settings/teachers"
                render={(props) => (
                  <Teachers
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/students"
                render={(props) => (
                  <Students
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/organization-setup"
                render={(props) => (
                  <OrganizationSetup
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/organization-profile"
                render={(props) => (
                  <OrganizationProfile
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/promote-students"
                render={(props) => (
                  <PromoteStudent
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/settings/user-creations"
                render={(props) => (
                  <UserCreations
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/notify-students"
                render={(props) => (
                  <NotifyStudents
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper"
                render={(props) => (
                  <CreateQuestionPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper"
                render={(props) => (
                  <OwnQuestionPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/custom"
                render={(props) => (
                  <OwnQuestionCustom
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/quiz_section"
                render={(props) => (
                  <Quiz
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/quiz_section/edit_quiz/EditQuizSection"
                render={(props) => (
                  <EditQuiz
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/"
                render={(props) => (
                  <HomeDashboard changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/questionsPreview"
                render={(props) => (
                  <QuestionsPreview
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/main-custom"
                render={(props) => (
                  <OwnQuestionCustompresent
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/old-exam"
                render={(props) => (
                  <OwnQuestionOldpresent
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/college-exam"
                render={(props) => (
                  <OwnQuestionCollegeExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/cumulative"
                render={(props) => (
                  <OwnQuestionCumulative
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/chapter"
                render={(props) => (
                  <OwnQuestionChapter
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/semi-grand"
                render={(props) => (
                  <OwnQuestionSemiGrand
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/grand"
                render={(props) => (
                  <OwnQuestionGrand
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/questions/manage-question-paper"
                render={(props) => (
                  <ManageQuestionPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/manage-question-paper/question-paper-result"
                render={(props) => (
                  <QuestionPaperResult
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings"
                render={(props) => (
                  <Settings
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/adaptive-question-paper"
                render={(props) => (
                  <AdaptiveQuestionPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/error-question"
                render={(props) => (
                  <ErrorQuestion
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/our-questions"
                render={(props) => (
                  <OurQuestions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/our-questions/manage-our-question-paper"
                render={(props) => (
                  <ManageOurQuestionPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/question-pattern"
                render={(props) => (
                  <QuestionPattern
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/question-pattern/create-question-pattern"
                render={(props) => (
                  <CreateQuestionPattern
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/create-custom-question-paper"
                render={(props) => (
                  <CreateCustomQuestionPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/create-custom-question-paper/create-custom-summery"
                render={(props) => (
                  <CreateCustomSummery
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/result-analysis"
                render={(props) => (
                  <ResultAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/practice-exam-analysis"
                render={(props) => (
                  <PracticeExamAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/strength-analysis"
                render={(props) => (
                  <StrengthAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/time-analysis"
                render={(props) => (
                  <TimeAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/complexity-analysis"
                render={(props) => (
                  <ComplexityAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/error-analysis"
                render={(props) => (
                  <ErrorAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questiontype-analysis"
                render={(props) => (
                  <QuestionTypeAnalysisCollege
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notifications/notification"
                render={(props) => (
                  <Notification
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notifications"
                render={(props) => (
                  <AllNotifications
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              {/* Student Module */}
              <Route
                exact
                path="/student/ForgotPassword"
                render={(props) => (
                  <ForgotPassword
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/login"
                render={(props) => (
                  <StudentLogin
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/register"
                render={(props) => (
                  <StudentRegister
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/home"
                render={(props) => (
                  <StudentHome
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/learn-practice"
                render={(props) => (
                  <LearnPractice
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subjects"
                render={(props) => (
                  <Subjects
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/topics"
                render={(props) => (
                  <NewTopics changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/student/subject/chapter"
                render={(props) => (
                  <Chapter changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/student/subject/chapter-status"
                render={(props) => (
                  <OverAllChapterStrength
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/practice-exam-history"
                render={(props) => (
                  <PracticeAndExamHistory
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/exam-history"
                render={(props) => (
                  <ExamHistory
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/start-error-exam"
                render={(props) => (
                  <StartErrorExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/start-watching"
                render={(props) => (
                  <WatchingVideo
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/video-watching"
                render={(props) => (
                  <SingleVideo
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/start-learning"
                render={(props) => (
                  <RevisionMaterial
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/short-notes"
                render={(props) => (
                  <SingleShortNote
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/practice-instructions"
                render={(props) => (
                  <PracticeInstructions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/custom-instructions"
                render={(props) => (
                  <CustomInstructions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/subject/practice-submitback"
                render={(props) => (
                  <PracticeSubmitback
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/custom-submitback"
                render={(props) => (
                  <CustomsubmitBack
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/subject/practice-test"
                render={(props) => (
                  <PracticeExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/student-assist-exam/:exam_session_id/:exam_type"
                render={(props) => (
                  <StudentAssistentExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/view-question-answer"
                render={(props) => (
                  <ViewQuestionAnswer
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/practice-view-question-answer"
                render={(props) => (
                  <PracticeViewQuestionAnswer
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/practice-errortest"
                render={(props) => (
                  <PracticeErrorExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/subject/exam"
                render={(props) => (
                  <CustomExamTest
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/exams"
                render={(props) => (
                  <Exam changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/student/exams/schedule-exam"
                render={(props) => (
                  <ScheduleExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/exams/total-exams-history"
                render={(props) => (
                  <ExamsHistory
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/exams/custom-exam"
                render={(props) => (
                  <CustomExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/exams/previous-paper-exam"
                render={(props) => (
                  <PreviousPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/exams/custom-previous-paper-exam"
                render={(props) => (
                  <CustomPreviousPaper
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/exams/adaptive-exam"
                render={(props) => (
                  <AdaptiveExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/exams/error-exam"
                render={(props) => (
                  <ErrorExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/get-ready-for-exam"
                render={(props) => (
                  <GetReadyForExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/chapter-exam"
                render={(props) => (
                  <ChapterExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/cumulative-exam"
                render={(props) => (
                  <CumulativeExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/semigrand-exam"
                render={(props) => (
                  <GetReadySemiGrandExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/grand-exam"
                render={(props) => (
                  <GetReadyGrandExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/history"
                render={(props) => (
                  <GetReadyExamHistory
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/upcoming-history"
                render={(props) => (
                  <GetReadyExamUpcomingHistory
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/get-ready-shortnotes-and-materials"
                render={(props) => (
                  <GetReadyShortNoteMaterialRevisions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/get-ready-for-exam/get-ready-shortnotes/single-shortnote"
                render={(props) => (
                  <GetReadySingleShortNoteMaterialRevisions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/bookmark"
                render={(props) => (
                  <Bookmarks
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/bookmark/videos"
                render={(props) => (
                  <BookmarkVideos
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/bookmark/videos/watch-video"
                render={(props) => (
                  <SingleBookmarkVideo
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/bookmark/shortnotes-and-materials"
                render={(props) => (
                  <BookmarkShortnotesMaterials
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/bookmark/shortnotes-and-material/single-shortnote"
                render={(props) => (
                  <BookmarkSingleShortNoteMaterialRevisions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/bookmark/practice-questions"
                render={(props) => (
                  <BookmarkPracticeQuestions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/bookmark/exam-questions"
                render={(props) => (
                  <BookmarkExamQuestions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/profile"
                render={(props) => (
                  <Profile changeToggle={() => this.menuToggler()} {...props} />
                )}
              />

              <Route
                exact
                path="/student/notes"
                render={(props) => (
                  <Notes changeToggle={() => this.menuToggler()} {...props} />
                )}
              />
              <Route
                exact
                path="/student/notes/videos"
                render={(props) => (
                  <NoteVideos
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notes/videos/watch-video"
                render={(props) => (
                  <SingleNotesVideo
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notes/shortnotes-and-materials"
                render={(props) => (
                  <NotesShortnotesMaterials
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notes/shortnotes-and-material/single-shortnote"
                render={(props) => (
                  <NotesSingleShortNoteMaterialRevisions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notes/practice-questions"
                render={(props) => (
                  <NotesPracticeQuestions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notes/exam-questions"
                render={(props) => (
                  <NotesExamQuestions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/notes/shortnotes-and-material/single-revisions-material"
                render={(props) => (
                  <NotesSingleMaterialRevisions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/result-analysis"
                render={(props) => (
                  <ResultAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/practice-exam-analysis"
                render={(props) => (
                  <PracticeExamAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/strength-analysis"
                render={(props) => (
                  <StrengthAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/time-analysis"
                render={(props) => (
                  <TimeAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/complexity-analysis"
                render={(props) => (
                  <ComplexityAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/error-analysis"
                render={(props) => (
                  <ErrorAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/questiontype-analysis"
                render={(props) => (
                  <QuestionTypeAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/package"
                render={(props) => (
                  <StudentPackage
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/revision-material-groups"
                render={(props) => (
                  <RevisionMaterialGroups
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/revision-material-groups/custom-revision-materials"
                render={(props) => (
                  <CustomRevisionMaterials
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/customEdit"
                render={(props) => (
                  <OwnQuestionCustomEdit
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/revision-material-groups/custom-single-revision-material"
                render={(props) => (
                  <CustomSingleRevisionMaterial
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/lec_paper_generator"
                render={(props) => (
                  <LecPaperGenerator
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/lec_paper_generator/edit_lec_paper/EditTestSection"
                render={(props) => (
                  <EditLecPaperGenerator
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/mocktest-analysis"
                render={(props) => (
                  <MocktestAnalysis
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/attendance"
                render={(props) => (
                  <StudentAttendance
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/attendance-report"
                render={(props) => (
                  <StudentAttendanceReport
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/marks-upload"
                render={(props) => (
                  <StudentMarksUploading
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/student/offline-fee-structure"
                render={(props) => (
                  <OfflineFeeStructure
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student/offline-exam-results"
                render={(props) => (
                  <OfflineExamResults
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/Fee-Structure"
                render={(props) => (
                  <FeeStructure
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/instituteStudents"
                render={(props) => (
                  <EducationManagementStudents
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/settings/employee-restrictions"
                render={(props) => (
                  <EmployeeRestrictions
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/Employee_Attendance"
                render={(props) => (
                  <EmployeeAttendance
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/Employee_Attendance_Report"
                render={(props) => (
                  <EmployeeAttendanceReport
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student-admission"
                render={(props) => (
                  <StudentAdmission
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/lecturer-timeTable"
                render={(props) => (
                  <LecturerTimeTable
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />


              <Route
                exact
                path="/student-admission-list"
                render={(props) => (
                  <StudentAdmissionList
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/Student_Gate_Pass"
                render={(props) => (
                  <GatePass
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/Parent_Notification"
                render={(props) => (
                  <ParentNotification
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />


              <Route
                exact
                path="/student-diary"
                render={(props) => (
                  <StudentDiary
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/Student_profile"
                render={(props) => (
                  <StudentOrganizationProfileEamcet
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/student-permission"
                render={(props) => (
                  <StudentPermission
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/hostel-attendance"
                render={(props) => (
                  <HostelAttendance
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />


              <Route
                exact
                path="/building-creation"
                render={(props) => (
                  <BuildingCreation
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/hostel/attendance-report"
                render={(props) => (
                  <HostelAttendanceReport
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />


              <Route
                exact
                path="/material-assigning"
                render={(props) => (
                  <MeatrialAssigning
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />


              <Route
                exact
                path="/material-report"
                render={(props) => (
                  <MaterialReport
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/material-store"
                render={(props) => (
                  <MaterialStore
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/assignment"
                render={(props) => (
                  <Assignment
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/assignment/view_details"
                render={(props) => (
                  <AssignmentNextPage
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/lead-management"
                render={(props) => (
                  <LeadManagement
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/lead-management/leads_followups"
                render={(props) => (
                  <LeadsFollowups
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route

                exact
                path="/enquiry-links"
                render={(props) => (
                  <EnquiryLink
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/inst_revision_material"
                render={(props) => (
                  <InstitureRevisionMaterial
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path="/lead-management-home"
                render={(props) => (
                  <LeadManagementNew
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />




              <Route exact path='/student/video-order-summary' render={(props) => (<OrderSummary changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/subject/start-video-watching' render={(props) => (<SingleVideoWatching changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/feedback' render={(props) => (<StudentFeedBack changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/previous-paper-analysis' render={(props) => (<PreviousPaperAnalysis changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/linkage-chapter-analysis' render={(props) => (<LinkageChapterAnalysis changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/subject/exam-result' render={(props) => (<PracticeTestExamResult changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/subject/practice-result' render={(props) => (<PracticeExamResult changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/subject/custompractice-result' render={(props) => (<CustomPracticeExamResult changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/custom-practise-exam' render={(props) => (<CustomPractiseExam changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/videos' render={(props) => (<Videos changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route exact path='/student/videos/recently-watched' render={(props) => (<VideosRecentlyWatched changeToggle={() => this.menuToggler()} {...props} />)} />
              <Route path="/student/loading" component={StudentLoading} />
              <Route path="/student/*" component={StudentPageNotFound} />
              <Route
                exact
                path="/questions/create-question-paper/own-question-paper/mock-exam"
                render={(props) => (
                  <OwnQuestionMockExam
                    changeToggle={() => this.menuToggler()}
                    {...props}
                  />
                )}
              />

              <Route path="*" component={PageNotFound} />
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
